import { Disclosure, Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, MenuIcon, XIcon } from "@heroicons/react/solid";
import classNames from "classnames";
import { Fragment, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import thlogo from "../asset/TH_logo.webp";
import user from "../asset/user.webp";
import "../styles/logo.css";
import { useLoginStore } from "./helpers/state";

export function Header() {
  const { login } = useLoginStore();
  const loggedInUser = login.user;

  const navigate = useNavigate();

  var CryptoJS = require("crypto-js");
  if (!login || login.jwtToken === null || !login.jwtToken) {
    navigate("/login");
  } else {
    try {
      let bytes = CryptoJS.AES.decrypt(
        login.jwtToken.toString(),
        `${process.env.SECRET_KEY}`
      );
      var userToken = bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Decryption error:", error);
    }
  }

  const userNavigation = [
    { name: "Profil Anda", href: "/myprofile", current: false },
    {
      name: "Log Keluar",
      href: "#", 
      current: false,
      onClick: logout,
    },
  ];

  function logout() {
    window.localStorage.clear();
    window.location.href = "/login";
  }

  function userMobile() {
    if (!loggedInUser) {
      return (
        <button className="bg-lime-700 text-white rounded-md p-2 text-base h-11 w-32 hover:bg-lime-800">
          <Link to="/login">Log Masuk</Link>
        </button>
      );
    } else if (loggedInUser) {
      return (
        <div>
          {userNavigation.map((item) => (
            <Disclosure.Button
              key={item.name}
              as="a"
              href={item.href}
              target="_blank"
              className={classNames(
                item.current
                  ? "bg-gray-900 text-white"
                  : "text-gray-500 hover:bg-gray-700 hover:text-white",
                "block px-3 py-2 rounded-md text-base font-medium"
              )}
              aria-current={item.current ? "page" : undefined}
              // @ts-ignore
              onClick={item.onClick ? item.onClick : null} 
            >
              {item.name}
            </Disclosure.Button>
          ))}
        </div>
      );
    }
  }

  function userLog() {
    if (!loggedInUser) {
      return (
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
          <button className="bg-lime-700 text-white rounded-md p-2 text-base h-11 w-32 hover:bg-lime-800">
            <Link to="/login">Log Masuk</Link>
          </button>
        </div>
      );
    } else if (loggedInUser) {
      return (
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
          <Menu as="div" className="ml-3 relative">
            <div>
              <Menu.Button className=" flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white">
                <img className="h-8 w-8 rounded-full" src={user} alt="" />
                <ChevronDownIcon
                  className="w-5 h-5 ml-2 -mr-1 text-gray-800 hover:text-black"
                  aria-hidden="true"
                />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className=" absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <Menu.Item>
                  {({ active }) => (
                    <a
                      href="/myprofile"
                      className={classNames(
                        active ? "bg-gray-100 " : "",
                        "block px-4 py-2 text-sm text-gray-700"
                      )}
                    >
                      Profil Anda
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={logout}
                      className={classNames(
                        active ? "bg-gray-100 " : "",
                        "block px-4 py-2 text-sm text-gray-700"
                      )}
                    >
                      Log Keluar
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      );
    }
  }

  useEffect(() => {
    userLog();
  }, [loggedInUser]);

  useEffect(() => {
    userMobile();
  }, [loggedInUser]);

  const navigation = [
    {
      name: "Utama",
      href: `http://e-bimbingan.tabunghaji.gov.my/verify-auth?token=${userToken}`,
      current: false,
    },
  ];

  return (
    <>
      <Disclosure as="nav" className="bg-white">
        {({ open }) => (
          <>
            <div className="sm:mx-24">
              <div className="flex items-center justify-between h-16">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <picture>
                      <img
                        className="max-h-28 max-w-36"
                        src={thlogo}
                        alt="Workflow"
                      />
                    </picture>
                  </div>
                  <div className="hidden md:block">
                    <div className="ml-10 flex items-baseline space-x-4">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          target="_blank"
                          rel="noreferrer"
                          className={classNames(
                            item.current
                              ? "bg-green-600 text-white"
                              : "text-gray-500 hover:underline",
                            "px-3 py-2 rounded-md text-md font-medium"
                          )}
                          aria-current={item.current ? "page" : undefined}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="hidden md:block">
                  <div className="ml-4 flex items-center md:ml-6">
                    {userLog()}
                  </div>
                </div>
                <div className="-mr-2 flex md:hidden">
                  <Disclosure.Button className="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-white hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>

              <Disclosure.Panel className="md:hidden">
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                  {navigation.map((item) => (
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      href={item.href}
                      className={classNames(
                        item.current
                          ? "bg-gray-900 text-white"
                          : "text-gray-500 hover:bg-gray-700 hover:text-white",
                        "block px-3 py-2 rounded-md text-base font-medium"
                      )}
                      aria-current={item.current ? "page" : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
                <div className="pt-4 pb-3 border-t">{userMobile()}</div>
              </Disclosure.Panel>
            </div>
          </>
        )}
      </Disclosure>
    </>
  );
}
